import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './CreditPurchase.css';

const PRICING_TIERS = [
  {
    id: 'price_10credits',
    credits: 10,
    price: '$5',
    pricePerCredit: '$0.50/credit',
    label: 'Starter',
    highlight: false,
  },
  {
    id: 'price_25credits',
    credits: 25,
    price: '$11',
    pricePerCredit: '$0.44/credit',
    label: 'Best Value',
    highlight: true,
  },
  {
    id: 'price_50credits',
    credits: 50,
    price: '$20',
    pricePerCredit: '$0.40/credit',
    label: 'Pro',
    highlight: false,
  },
];

function CreditPurchase({ onClose }) {
  const { getIdToken } = useAuth();
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState('');

  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

  async function handlePurchase(priceId) {
    setLoading(priceId);
    setError('');

    try {
      const token = await getIdToken();
      const response = await fetch(`${apiEndpoint}/credits/purchase`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ priceId }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create checkout session');
      }

      window.location.href = data.checkoutUrl;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(null);
    }
  }

  return (
    <div className="credit-purchase-overlay" onClick={onClose}>
      <div
        className="credit-purchase-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="credit-purchase-header">
          <h2 className="credit-purchase-title">Purchase Credits</h2>
          <p className="credit-purchase-subtitle">
            Each credit generates one AI miniature visualization
          </p>
          <button
            className="credit-purchase-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {error && (
          <div className="credit-purchase-error" role="alert">
            {error}
          </div>
        )}

        <div className="credit-tiers">
          {PRICING_TIERS.map((tier) => (
            <div
              key={tier.id}
              className={`credit-tier-card ${tier.highlight ? 'highlighted' : ''}`}
            >
              {tier.highlight && (
                <span className="tier-badge">Best Value</span>
              )}
              <div className="tier-label">{tier.label}</div>
              <div className="tier-credits">{tier.credits}</div>
              <div className="tier-credits-label">credits</div>
              <div className="tier-price">{tier.price}</div>
              <div className="tier-price-per">{tier.pricePerCredit}</div>
              <button
                className={`tier-btn ${tier.highlight ? 'tier-btn-primary' : 'tier-btn-secondary'}`}
                onClick={() => handlePurchase(tier.id)}
                disabled={loading !== null}
              >
                {loading === tier.id ? (
                  <span className="tier-btn-loading">
                    <span className="spinner-sm" />
                    Redirecting…
                  </span>
                ) : (
                  `Get ${tier.credits} Credits`
                )}
              </button>
            </div>
          ))}
        </div>

        <p className="credit-purchase-footer">
          Secure checkout powered by Stripe. No subscriptions — credits never expire.
        </p>
      </div>
    </div>
  );
}

export default CreditPurchase;
